// Ported from Studio Playground frontend/src/utils/boothCare.js.
export const normalizeCare = (text = '') => String(text)
  .normalize('NFKC')
  .toLocaleLowerCase()
  .replace(/['’‘]/g, '')
  .replace(/[-_]+/g, ' ')
  .replace(/\s+/g, ' ')
  .trim();

const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const hasPhrase = (text, phrase) => {
  const normalizedPhrase = normalizeCare(phrase);
  if (!normalizedPhrase) return false;
  const pattern = new RegExp(`(^|\\W)${escapeRegExp(normalizedPhrase)}(?=\\W|$)`, 'u');
  return pattern.test(text);
};

export const careMatch = (text, phrases = {}) => {
  const normalized = normalizeCare(text);
  if ((phrases.self_harm || []).some((phrase) => hasPhrase(normalized, phrase))) {
    return 'self_harm';
  }
  if ((phrases.harmed || []).some((phrase) => hasPhrase(normalized, phrase))) {
    return 'harmed';
  }
  return null;
};

export const careTextForSong = (song = {}) => [
  song.title || '',
  ...(song.sections || []).flatMap((section) => (
    (section.lines || []).map((line) => line.text || '')
  )),
].join('\n');
